<template>
  <el-dialog :title="content.title" :visible.sync="visible" :close-on-click-modal="false" width="80%">
    <el-form ref="form" label-position="top" label-width="150px" :model="form">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-tabs type="border-card">
            <el-tab-pane label="Coordonnées">
              <el-form-item prop="name" label="Nom">
                <el-input placeholder="Nom de l'entreprise" v-model="form.name"></el-input>
              </el-form-item>

              <el-form-item label="Adresse postale">
                <el-input placeholder="Numéro et nom la rue" v-model="form.address_street"></el-input>
              </el-form-item>

              <el-row :gutter="20">
                <el-col :span="14">
                  <el-form-item label="Code postal">
                    <el-input placeholder="Code postal" v-model="form.address_zip_code"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item label="Ville">
                    <el-input placeholder="Ville" v-model="form.address_city"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-tab-pane>
            <el-tab-pane label="Coordonnées publiques">
              <el-form-item prop="name" label="Nom">
                <el-input required :placeholder="form.name" v-model="form.public_name"></el-input>
              </el-form-item>

              <el-form-item label="Adresse postale">
                <el-input :placeholder="form.address_street" v-model="form.public_address_street"></el-input>
              </el-form-item>

              <el-row :gutter="20">
                <el-col :span="14">
                  <el-form-item label="Code postal">
                    <el-input :placeholder="form.address_zip_code" v-model="form.public_address_zip_code"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item label="Ville">
                    <el-input :placeholder="form.address_city" v-model="form.public_address_city"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-tab-pane>
          </el-tabs>
        </el-col>
        <el-col :span="12">
          <el-tabs type="border-card">
            <el-tab-pane label="Détails et activité">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item prop="type" label="Type">
                    <el-select class="form-control" v-model="form.type">
                      <el-option label="Client" value="CLIENT"></el-option>
                      <el-option label="Ancien client" value="FORMER_CLIENT"></el-option>
                      <el-option label="Prospect" value="PROSPECT"></el-option>
                      <el-option label="Grande agence" value="BIG_AGENCY"></el-option>
                      <el-option label="Liste noire" value="BLACKLIST"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item prop="user_id" label="Commercial associé">
                    <user-select v-on:change="onUserChange" :id="form.user_id"></user-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item prop="job" label="Type de métier">
                    <el-select class="form-control" v-model="form.job_type">
                      <el-option v-for="jobType in jobs.map(item => item.type)" :key="jobType" :value="jobType">{{ jobType }}</el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item prop="job" label="Métier">
                    <el-select class="form-control" v-model="form.job">
                      <el-option v-for="job in subJobs" :key="job" :value="job">{{ job }}</el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

            </el-tab-pane>
          </el-tabs>
        </el-col>
      </el-row>
      <el-row class="m-t-2" :gutter="20">
        <el-col :span="12">
          <el-tabs type="border-card">
            <el-tab-pane label="Informations de contact">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item prop="first_phone" label="Téléphone">
                    <el-input placeholder="Téléphone principal" v-model="form.first_phone"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item prop="second_phone" label="Téléphone secondaire">
                    <el-input placeholder="Téléphone secondaire" v-model="form.second_phone"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item prop="email" label="Email">
                <el-input placeholder="Email de la société" v-model="form.email"></el-input>
              </el-form-item>
              <el-form-item prop="website" label="Site internet">
                <el-input placeholder="Site internet de la société" v-model="form.website"></el-input>
              </el-form-item>
              <el-form-item prop="remarks" label="Infos importantes">
                <el-input type="textarea" autosize placeholder="Mettre les infos importantes détectées dans la préparation de l'appel: types de construction, régions couvertes par la prospect, etc… " v-model="form.remarks"></el-input>
              </el-form-item>
            </el-tab-pane>
          </el-tabs>
        </el-col>
        <el-col :span="12">
          <el-tabs type="border-card">
            <el-tab-pane label="Liaisons">
              <p class="text-danger">Quelques notes importantes sur la suppression d'une liaison :</p>
              <ul class="text-danger">
                <li>
                  La suppression d'une liaison aura pour effet de <strong>supprimer la fiche liée</strong>. Elle sera
                  re-créé dans l'interface lors de la prochaine synchronisation de l'application (toute les nuits).
                </li>
                <li>
                  Afin de ne pas perdre d'éléments, les documents, services, rappels, commentaires de la fiche déliée
                  seront conservés sur cette fiche. <strong>(Préférez délier des fiches vides pour ne pas garder des données
                  inutiles sur vos fiches)</strong>
                </li>
              </ul>
              <el-row :gutter="20" class="m-t-1">
                <div v-for="source in sources" :key="source.id">
                  <el-col :span="6"><source-app :name="source.id"></source-app></el-col>
                  <el-col :span="6">
                    <el-switch v-model="sourceStatus[source.id]" :disabled="!sourceStatus[source.id]" @change="onSourceChange(source.id)" on-text="" off-text="">
                    </el-switch>
                  </el-col>
                </div>
              </el-row>
            </el-tab-pane>
          </el-tabs>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button v-on:click="visible = false">Annuler</el-button>
      <el-button :type="content.button_type" v-on:click="submit(false)" :loading="loading">{{ content.button }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import UserSelect from '../Entities/Selects/UserSelect.vue'
  import SourceApp from '../Entities/SourceApp.vue'

  export default {
    components: {
      SourceApp,
      UserSelect},
    name: 'customer-modal',
    data () {
      return {
        visible: false,
        loading: false,
        content: {
          title: '',
          button: '',
          button_type: ''
        },
        jobs: [
          {
            type: 'Autre',
            name: []
          },
          {
            type: 'Métier de la construction',
            name: ['Constructeur', 'Maître d\'oeuvre', 'Entreprise générale du batiment', 'Architecte', 'Promoteur', 'Bureau d\'étude']
          },
          {
            type: 'Vendeur de bien',
            name: ['Lotisseur', 'Agence immobilière', 'Notaire', 'Marchand de bien', 'Mairie', 'Géomètre']
          },
          {
            type: 'Travaux et rénovation',
            name: ['Menuisier', 'Plombier', 'Chauffagiste']
          }
        ],
        form: {
          id: null,
          sources: {},

          // Coordonnées
          name: '',
          address_street: '',
          address_street_complement: '',
          address_zip_code: '',
          address_city: '',

          // Coordonnées Publiques
          public_name: '',
          public_address_street: '',
          public_address_street_complement: '',
          public_address_zip_code: '',
          public_address_city: '',

          user_id: this.$store.getters['users/current'].id,
          type: 'CLIENT',

          job: '',
          job_type: '',

          first_phone: '',
          second_phone: '',
          email: '',
          website: '',
          remarks: '',
        }
      }
    },
    computed: {
      users () {
        return this.$store.getters['users/all']
      },
      sources () {
        return this.$model.source_app.get()
      },
      sourceStatus () {
        let sources = {}

        for (let i = 0; i < this.sources.length; i++) {
          if (this.sources[i].id in this.form.sources && this.form.sources[this.sources[i].id] !== null) {
            sources[this.sources[i].id] = this.sources[i].id in this.form.sources
          }
        }

        return sources
      },
      subJobs () {
        let jobType = this.jobs.find(item => item.type === this.form.job_type)

        if (jobType) {
          return jobType.name
        } else {
          return []
        }
      }
    },
    watch: {
      visible (visible) {
        if (!visible) {
          this.reset()
        }
      }
    },
    mounted () {
      let self = this

      this.$model.customer.on('create', () => {
        self.content.title = 'Création d\'un client ou prospect'
        self.content.button = 'Créer la fiche'
        self.content.button_type = 'success'

        self.visible = true
      })

      this.$model.customer.on('edit', ({item}) => {
        self.content.title = 'Modification d\'un client ou prospect'
        self.content.button = 'Modifier la fiche'
        self.content.button_type = 'warning'

        self.load(item)

        self.visible = true
      })
    },
    methods: {
      reset () {
        this.form = this.$options.data.apply(this).form
        this.$refs['form'].resetFields()
      },
      load (item) {
        if (item) {
          if (item.id) this.form.id = item.id
          if (item.sources) this.form.sources = Object.assign({}, item.sources)
          if (item.name) this.form.name = item.name
          if (item.address.street) this.form.address_street = item.address.street
          if (item.address.street_complement) this.form.address_street_complement = item.address.street_complement
          if (item.address.zip_code) this.form.address_zip_code = item.address.zip_code
          if (item.address.city) this.form.address_city = item.address.city
          if (item.public.name) this.form.public_name = item.public.name
          if (item.public.street) this.form.public_address_street = item.address_street
          if (item.public.street_complement) this.form.public_address_street_complement = item.public.street_complement
          if (item.public.zip_code) this.form.public_address_zip_code = item.public.zip_code
          if (item.public.city) this.form.public_address_city = item.public.city
          if (item.user_id) this.form.user_id = item.user_id
          if (item.type) this.form.type = item.type
          if (item.job_type) this.form.job_type = item.job_type
          if (item.job) this.form.job = item.job
          if (item.contact_details.first_phone) this.form.first_phone = item.contact_details.first_phone
          if (item.contact_details.second_phone) this.form.second_phone = item.contact_details.second_phone
          if (item.contact_details.email) this.form.email = item.contact_details.email
          if (item.contact_details.website) this.form.website = item.contact_details.website
          if (item.contact_details.remarks) this.form.remarks = item.contact_details.remarks
        }
      },
      submit () {
        let self = this

        this.$refs['form'].validate((valid) => {
          if (valid) {
            let p

            if (this.form.id === null) {
              p = self.$model.customer.api().create(this.form)
            } else {
              p = self.$model.customer.api().update(this.form.id, this.form)
            }

            p.then(() => {
              self.visible = false
            })
          } else {
            self.$message.error('Impossible de valider le formulaire. Merci de vérifier les valeurs saisies')
          }
        })
      },
      onUserChange (id) {
        if (id !== null) {
          id = this.users.find(user => user.id === id).id
        }

        this.form.user_id = id
      },
      onSourceChange (source) {
        this.form.sources[source] = null
      }
    }
  }
</script>



// WEBPACK FOOTER //
// CustomerModal.vue?260efe4c